import { fetchPdf, fetchContractData } from '../../api/contractApi';

const GET_CONTRACT_DATA = 'efes/contract/GET_CONTRACT_DATA';
const GET_CONTRACT_DATA_SUCCESS = 'efes/contract/GET_CONTRACT_DATA_SUCCESS';
const GET_CONTRACT_DATA_FAIL = 'efes/contract/GET_CONTRACT_DATA_FAIL';
const CLEAN_CONTRACT = 'efes/contract/CLEAN_CONTRACT';
const SET_LEAVE_CONTRACT_PAGE = 'efes/contract/SET_LEAVE_CONTRACT_PAGE';

const initialState = {
  contractData: null,
  contractPdf: null,
  loading: false,
  error: null,
  leaveContractPage: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONTRACT_DATA:
      return {
        ...state,
        loading: true,
      };
    case GET_CONTRACT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        contractData: action.result.data,
        contractPdf: action.result.pdf,
      };
    case GET_CONTRACT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CLEAN_CONTRACT:
      return {
        contractData: null,
        contractPdf: null,
        loading: false,
        error: null,
      };
    case SET_LEAVE_CONTRACT_PAGE:
      return {
        ...state,
        leaveContractPage: action.data,
      };

    default:
      return state;
  }
}

export const cleanUp = () => ({
  type: CLEAN_CONTRACT,
});

export const getContractData = (type, id) => {
  const contractDataPdf = [
    fetchContractData(type, id),
    fetchPdf(type, id),
  ];

  return {
    actions: [
      { type: GET_CONTRACT_DATA },
      { type: GET_CONTRACT_DATA_SUCCESS },
      { type: GET_CONTRACT_DATA_FAIL },
    ],
    promise: Promise.all(contractDataPdf).then(([data, pdf]) => ({
      data,
      pdf,
    })),
  };
};

export const setLeaveContractPage = (isLeaving) => ({
  type: SET_LEAVE_CONTRACT_PAGE,
  data: isLeaving,
});
